var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var notificationsChannel = Radio.channel('notifications');

var CommonUtils = require('../../utils/common-utils.js');

var SetDocumentDueForm = Marionette.View.extend({
    template: require('../../templates/documents/set-document-due-form.html'),

    ui: {
        modal: '#set-due-modal',
        dueDate: '#due-date',
        save: '#save'
    },

    events: {
        'click @ui.save': 'onSave'
    },

    initialize: function (options) {
        var that = this;
        that.utils = new CommonUtils();
        that.docIds = options.docIds;
        that.selectedDate = null;
    },

    onRender: function () {
        var that = this;
        that.ui.dueDate.datetimepicker({
            showClear: true,
            showClose: true,
            useCurrent: false,
            format: 'MM/DD/YYYY hh:mm A'
        });
        that.ui.dueDate.on("dp.change", function (e) {

            if (e.date) {
                that.ui.save.removeAttr('disabled');
                that.selectedDate = e.date.valueOf();
            } else {
                that.ui.save.attr('disabled', true);
                that.selectedDate = null;
            }
        }).on('dp.show', function () {
            return $(this).data('DateTimePicker').defaultDate(that.utils.getDateWithoutTime(new Date()));
        });

        that.show();
    },

    onSave: function () {
        var that = this;
        if (that.docIds == [] || _.isEmpty(that.docIds) || !that.selectedDate)
            return;

        that.utils.showSpinner("#set-due-loader");
        $.ajax({
            type: "POST",
            url: '/api/document/due/' + that.selectedDate,
            data: JSON.stringify(that.docIds),
            contentType: 'application/json',
            statusCode: {
                200: function (response) {
                    that.utils.hideSpinner("#set-due-loader");
                    that.hide();
                    $.notify({
                        message: 'Due date set successfully'
                    }, {
                        type: 'success',
                        z_index: 2000,
                    });
                    if (that.getOption("woResponseEvent") !== true)
                        that.triggerMethod('due:set:to:document', {
                            documentsIdWithErrors: response,
                            selectedDate: that.selectedDate
                        });
                }
            },
            error: function (e) {
                that.utils.hideSpinner("#set-due-loader");
                notificationsChannel.request('show:notification', e.responseJSON);
            }
        });
    },

    show: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },

    hide: function () {
        this.ui.modal.modal('hide');
    }
});

module.exports = SetDocumentDueForm;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/set-document-due-form.js
// module id = 320
// module chunks = 0